import { render } from "./ModuleLanguageCurrency.vue?vue&type=template&id=99b05ae2"
import script from "./ModuleLanguageCurrency.vue?vue&type=script&lang=js"
export * from "./ModuleLanguageCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__